
document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-j-burger]');
  const m=document.querySelector('[data-j-mobile]');
  if(b&&m){
    const close=()=>{m.classList.remove('open');b.setAttribute('aria-expanded','false');};
    b.setAttribute('aria-expanded','false');
    b.addEventListener('click',()=>{
      const open=!m.classList.contains('open');
      m.classList.toggle('open',open);
      b.setAttribute('aria-expanded',open?'true':'false');
    });
    m.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));

    m.querySelectorAll('[data-j-subtoggle]').forEach(toggle=>{
      toggle.addEventListener('click',()=>{
        const group=toggle.closest('[data-j-mobile-group]');
        if(!group)return;
        const willOpen=!group.classList.contains('is-open');
        m.querySelectorAll('[data-j-mobile-group]').forEach(g=>{
          g.classList.remove('is-open');
          const t=g.querySelector('[data-j-subtoggle]');
          if(t)t.setAttribute('aria-expanded','false');
        });
        if(willOpen){
          group.classList.add('is-open');
          toggle.setAttribute('aria-expanded','true');
        }
      });
    });

    document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
  }

  document.querySelectorAll('[data-j-product]').forEach(root=>{
    const raw=root.querySelector('[data-j-variants]');
    if(!raw)return;
    let variants=[];
    try{variants=JSON.parse(raw.textContent)}catch(e){return}
    const selects=[...root.querySelectorAll('[data-j-option]')];
    const idInput=root.querySelector('input[name="id"]');
    const price=root.querySelector('[data-j-price]');
    const submit=root.querySelector('button[type="submit"]');

    const update=()=>{
      const selected=selects.map(s=>s.value);
      const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!variant)return;
      if(idInput)idInput.value=variant.id;
      if(price)price.textContent=new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(variant.price/100);
      if(submit){
        submit.disabled=!variant.available;
        submit.textContent=variant.available?'Ajouter au panier':'Indisponible';
      }
      const u=new URL(window.location.href);
      u.searchParams.set('variant',variant.id);
      history.replaceState({},'',u);
    };
    selects.forEach(s=>s.addEventListener('change',update));
    update();
  });
});
